module.exports = __webpack_public_path__ + "fonts/Arsenal-Regular.f51e4503.ttf";